import React from 'react';
import { Link } from 'react-router-dom';
//importing carousel
import Carousel from 'react-elastic-carousel';
//importing styled components
import styled from 'styled-components';
//importing data
import hardwareData from '../../data/hardwareData';
import Product from './Product';

const HardwareSection = () => {
    let products = hardwareData();
    const hardProducts = products.slice(0, 4);
    return (
        <div>
            <HeaderDiv>
                <h3>Hardwares</h3>
            </HeaderDiv>
            <Container>
                <Products>

                    {
                        hardProducts.map(item => (
                            <Product
                                item={item}
                            />
                        ))
                    }
                </Products>
                <MoreButton>
                    <Link to="/hardware">Check Out More..</Link>
                </MoreButton>
            </Container>
        </div>
    )
}

export default HardwareSection

// const Item = styled.div`
//     height: 23rem;
//     width: 20rem;
//     background-color: #fff;
//     margin: 2rem;
//     padding: 1rem;
//     @media screen and (max-width:900px){
//         margin: 0.3rem
//     }
// `

const Products = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`

const Container = styled.div`
    width: 100%;
    margin: 1rem 0rem;
    padding-bottom: 3rem;
    /* padding: 0.5rem; */
`

const StyledCarousel = styled(Carousel)`
    /* margin: 20rem, 6rem; */
    background: #EAEDED;
`
const CarouselDiv = styled.div`
    padding: 2rem;
`

// const HThree = styled.h3`
//     color: #282828;
//     display: inline-block;
//     margin-left: 2rem;
//     font-size: 1.5rem;
//     border-bottom: 0.5rem solid #23d997;
// `

const HeaderDiv = styled.div`
    h3{
        color: #e21f36;
        display: inline-block;
        margin-left: 2rem;
        font-size: 1rem;
        font-weight: 700;
        border-bottom: 0.2rem solid #e21f36;
    }
    /* margin-left: 0; */
    @media screen and (max-width:900px){
        display: flex;
        align-items: center;
        justify-content: center;
        h3{
            margin-left: 0rem;
        }
    }
`


const MoreButton = styled.div`
    width: 100%;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0rem;
    margin-top: 1rem;
    a {
    // display: block;
    text-align: center;
    text-decoration: none;
    padding: 0.6rem 1rem;
    font-size: 1.3rem;
    color: white;
    transition: 0.3s ease;
    margin: 1rem 1rem 0rem 1rem;
    border: none;
    transition: all 0.5s ease;
    background-color: #e21f36;
    box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.4) inset;
    &:hover {
      background: orangered;
    }
    @media screen and (max-height: 900px) {
      padding: 0.6rem;
      font-size: 1.1rem;
    }
  }
`



















{/* <h3>software</h3>
            <Carousel itemsToShow={3}>
                <Item>1</Item>
                <Item>2</Item>
                <Item>3</Item>
                <Item>4</Item>
                <Item>5</Item>
                <Item>6</Item>
            </Carousel> */}